export { DeleteObjectModal } from "./DeleteObjectModal";
